import { Auth } from "aws-amplify";

export default ({ email, code, password }) =>
  Auth.forgotPasswordSubmit(email, code, password);
